import React from "react";
import "./i18n";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./assets/styles/global.css";
import { applyStoredTheme } from "./theme";

applyStoredTheme();
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
